import "core-js/modules/es.array.splice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'UpLoadFileDialog',
  props: {
    uploadFiledDialogShow: {
      type: Boolean,
      default: false
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    dialogFileTitle: {
      type: String,
      default: ''
    },
    demoTitle: {
      type: String,
      default: ''
    },
    upTitle: {
      type: String,
      default: ''
    },
    tipsTitle: {
      type: String,
      default: ''
    },
    accept: {
      type: String,
      default: '.xlsx'
    }
  },
  data: function data() {
    return {
      localLoading: false,
      error_num: 0,
      uploadNumInfo: {},
      haveError: false
    };
  },
  watch: {
    uploadFiledDialogShow: function uploadFiledDialogShow(val) {
      if (!val) {
        this.uploadNumInfo = {};
      }
      this.$parent.packageFile = '';
      this.haveError = false;
    }
  },
  methods: {
    httpRequest: function httpRequest(file) {
      this.$emit('emitUpload', file);
    },
    changeFile: function changeFile(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },
    beforeFileUpload: function beforeFileUpload(file) {
      var isLt1M = file.size / 1024 / 1024 < 10;
      if (!isLt1M) {
        this.$message.error('上传文件大小不能超过 10M!');
      }
      return isLt1M;
    },
    handleRemove: function handleRemove() {
      this.$parent.packageFile = '';
    },
    downDemo: function downDemo() {
      this.$emit('emitDownDemo');
    },
    saveUploadFile: function saveUploadFile() {
      this.$emit('emitSaveFile');
    },
    // 查看错误信息
    watchUploadFileError: function watchUploadFileError() {
      this.$emit('emitErrorFile');
    },
    closeDiaLog: function closeDiaLog() {
      this.$parent.uploadFiledDialogShow = false;
    }
  }
};